<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33331 8H12.6666" stroke="#1B1B1B" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 3.33301L12.6667 7.99968L8 12.6663" stroke="#1B1B1B" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
